export { LpFavoriteProductsHeaderComponent } from './header/lp-favorite-products-header.component';
